import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Tips from "./pages/Conseils";
import Assistante from "./pages/Assistante";
import Defouloir from "./pages/Defouloir";
import Jeux from "./pages/Jeux";
import Humeur from "./pages/Humeur";
import Wins from "./pages/Wins";
import Coulisses from "./pages/Coulisses";
import MascotJourney from "./pages/MascotJourney";
import Presse from "./pages/Presse";
import { LangProvider } from "./lib/i18n";
import usePageViewTracking from "./lib/usePageViewTracking";

function AppRoutes() {
  usePageViewTracking();
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/tips" element={<Tips />} />
        <Route path="/conseils" element={<Tips />} />
        <Route path="/ask" element={<Assistante />} />
        <Route path="/assistante" element={<Assistante />} />
        <Route path="/breathe" element={<Defouloir />} />
        <Route path="/defouloir" element={<Defouloir />} />
        <Route path="/quiz" element={<Jeux />} />
        <Route path="/jeux" element={<Jeux />} />
        <Route path="/mood" element={<Humeur />} />
        <Route path="/humeur" element={<Humeur />} />
        <Route path="/wins" element={<Wins />} />
        <Route path="/coulisses" element={<Coulisses />} />
        <Route path="/mascot/:emotion" element={<MascotJourney />} />
        <Route path="/sparky" element={<Navigate to="/mascot/joy" replace />} />
        <Route path="/presse" element={<Presse />} />
        <Route path="/press" element={<Presse />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <LangProvider>
      <div className="App">
        <Toaster position="top-center" richColors closeButton />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </div>
    </LangProvider>
  );
}

export default App;
